/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import { useMemo } from "react";
import Skeleton from "components/common/Skeleton";

/**
 * @param {Object} params
 * @param {number} params.length
 * @param {Array} params.columns
 * @param {Array} params.data
 * @param {boolean} params.isLoading
 * @param {JSX.Element} [cell]
 *
 * @return {{ data: Array, columns: Array }};
 * */
export default function useTableState({ length, columns, data, isLoading, cell = <Skeleton /> }) {
  const skeletonData = useMemo(() => Array(length).fill({}), [length]);

  return useMemo(() => {
    if (!isLoading) return { data, columns };

    return {
      data: skeletonData,
      columns: columns.map((column) => ({ ...column, cell })),
    };
  }, [cell, columns, data, isLoading, skeletonData]);
}
